var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-indicator text-center"},[_c('div',{class:_vm.spinnerClass})])}
var staticRenderFns = []

export { render, staticRenderFns }